var exports = {
  "Qw": "UsernameCardArt.module__art___Tm1rUG",
  "Sl": "UsernameCardArt.module__image___Tm1rUG",
  "qf": "UsernameCardArt.module__placeholder___Tm1rUG",
  "UU": "UsernameCardArt.module__name___Tm1rUG",
};

module.exports = exports;
